// src/config/config_karate.js
const API_BASE_KARATE_URL = "https://karatesoftdbbackend-production.up.railway.app";
// const API_BASE_KARATE_URL = "http://localhost:3000";
// const API_BASE_KARATE_URL = "http://192.168.18.38:3000";
export default API_BASE_KARATE_URL;